import { createUseMutation } from 'api/common/createUseMutation'
import { deleteGroupApi } from 'api/groups/fetchers/deleteGroupApi'

export const useDeleteGroupApi = createUseMutation({ fetcher: deleteGroupApi })
